import { render, staticRenderFns } from "./Branch_List.vue?vue&type=template&id=437b395e&scoped=true"
import script from "./Branch_List.vue?vue&type=script&lang=js"
export * from "./Branch_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b395e",
  null
  
)

export default component.exports